<template>
<el-table :data="tableData" style="width: 100%" :show-header="true" @row-click="gotoEdit">
    <el-table-column label="nome" width="260">
        <template slot-scope="scope">
            <div class="d-flex justify-content-start align-items-center">
                <div class="d-flex justify-content-start align-items-center">
                    <NameInitials :name="scope.row.name" small color="#727D94"/>
                </div>
                <p class="c-ndarkfour medium mb-0 break-name">
                    {{ scope.row.name | formatName }}
                </p>
            </div>
        </template>
    </el-table-column>
    <el-table-column label="permissão" width="160" v-if="this.$route.params.idCNPJ">
        <template slot-scope="scope">
            <div class="d-flex justify-content-start align-items-center">
                <caption class="mb-0">
                    {{ scope.row.userCnpjs.accessLevel == 0 ? 'administrador' : 'operacional'}}
                </caption>
            </div>
        </template>
    </el-table-column>
    <el-table-column width="160px" label="status">
        <template slot-scope="scope">
            <div class="d-flex align-items-center">
                <div>
                    <UserStatus :status="scope.row.emailChecked" />
                </div>
            </div>
        </template>
    </el-table-column>
    <el-table-column min-width="10px" label="">
    </el-table-column>
    <el-table-column width="80px" label="" >
        <template slot-scope="scope">
            <div class="d-flex justify-content-end align-items-center">
                <el-dropdown trigger="click" >
                    <Button :color="getPrimaryColor" type="secondary" size="small">Ações</Button>
                    <el-dropdown-menu slot="dropdown">

                            <ActionBtnItemsContainer>
                                <el-dropdown-item v-if="!scope.row.emailChecked && USER_TYPE_MIXIN.isAdm && $route.path == '/user' && scope.row.cnpjs.length > 0">
                                    <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="resendInvitation(scope.row)">
                                        <Mail class="mr-2" color="#A1A8B8" :hasCircle="false" size="16"/>Reenviar convite
                                    </span>
                                </el-dropdown-item>
                            </ActionBtnItemsContainer>

                            <el-dropdown-item>
                                <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="gotoEditButton(scope.row)">
                                    <Edit class="mr-2"/>Editar
                                </span>
                            </el-dropdown-item>

                            <el-dropdown-item v-if="showDelete(scope.row.id)">
                                <span class="c-sredfour medium pl-3 d-flex align-items-center" @click="deleteUser(scope.row.id)">
                                    <TrashIcon color="#E54949" class="mr-2"/>Excluir
                                </span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                </el-dropdown>
            </div>
        </template>
    </el-table-column>
</el-table>
</template>

<script>
import NameInitials from '@/components/icons/NameInitials'
import UserStatus from '@/components/status/UserStatus'
import Edit from '@/components/icons/Edit'
import TrashIcon from '@/components/icons/Trash'
import Mail from '@/components/icons/Mail'

// apis
import resendInvitation from '@/api/resendInvitation'

// Container
import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer'

export default {
    components: {
        NameInitials,
        UserStatus,
        Edit,
        TrashIcon,
        Mail,
        ActionBtnItemsContainer,
    },
    props: {
        tableData: {
            required: true
        }
    },
    methods: {
        showDelete(id) {
            if (this.$route.params.idCNPJ) {
                return true
            }

            const user = this.tableData.find(tableRow => tableRow.id === id)

            if (user.cnpjs.length > 0) {
                const isAdm = user.cnpjs.some(cnpj => cnpj.userCnpjs.accessLevel === 1)
                return !isAdm
            } else {
                return true
            }

        },
        deleteUser(id) {
            if (this.$route.params.idCNPJ) {
                this.$emit('deleteUserModal', id)
                return
            } else {
                const user = this.tableData.find(tableRow => tableRow.id == id)
                const showWarning = user.cnpjs.length > 0
                this.$emit('deleteUserModal', { id, showWarning })
            }
        },
        gotoEditButton(row) {
            if (this.$route.params.idCNPJ) {
                this.$router.push(`/user/company/${this.$route.params.idCNPJ}/edit/${row.id}`)
            } else {
                this.$router.push(`/user/edit/${row.id}`)
            }
        },
        gotoEdit(row, column) {
            if (column.width != 80 && !this.USER_TYPE_MIXIN.isBackOffice) {
                if (this.$route.params.idCNPJ) {
                    this.$router.push(`/user/company/${this.$route.params.idCNPJ}/edit/${row.id}`)
                } else {
                    this.$router.push(`/user/edit/${row.id}`)
                }
            }
        },
        async resendInvitation(row) {
            if (!row.emailChecked) {
                const result = await resendInvitation({
                    userId: row.id,
                })
                if (result.ok) {
                    this.$notify({
                        title: 'Convite reenviado com sucesso.',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false
                    }); 
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
